import { Component, OnInit } from '@angular/core';
import { City } from 'src/app/_models/city.model';
import { CityService } from 'src/app/_services/city.service';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { baseUrl, environment } from 'src/environments/environment';
import { sortTable } from 'src/app/helpers/sort-table';

@Component({
  selector: 'app-cities-list',
  templateUrl: './cities-list.component.html',
  styleUrls: ['./cities-list.component.scss'],
})
export class CitiesListComponent implements OnInit {
  pageTitle: string = 'Cities';
  placeholder: string = 'Search by city name …';
  cities: City[] = [];
  filteredCities: City[] = [];
  invertSort: boolean = false;
  theadArray = [
    'City Arabic Name',
    'City English Name',
    'City Active',
    'Edit City',
  ];

  constructor(private cityService: CityService, public toastr: ToastrService) {}

  ngOnInit(): void {
    this.getAllCities();
  }

  getAllCities() {
    this.cityService.getAllCities().subscribe((res) => {
      res.map((city: City) => {
        this.cities.push(city);
      });

      this.filteredCities = [...this.cities];
    });
  }

  onSearchCity(searchString) {
    this.cityService.searchByName(searchString).subscribe((response) => {
      this.filteredCities = response['data'];
    });
  }

  onSearchInputKeyup(searchString) {
    if (!searchString) {
      this.filteredCities = [...this.cities];
    }
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredCities = sortTable(
      this.filteredCities,
      'name',
      this.invertSort
    );
  }

  onCityActiveChange(event, city) {
    city.isActive = event.target.checked;

    this.cityService.updateCity(city).subscribe((response) => {

      showNotification(
        'success',
        `${response.data.enName} city has been ${
          response.data.isActive ? 'Activated' : 'Deactivated'
        }`,
        this.toastr
      );
    });
  }
}
